module.exports = __webpack_public_path__ + "img/yunwei.eb390eb0.png";